<template>
	<div class="shop-intro">
		<ul class="bread-crumb" v-if="!status.fetchCategories.loading">
			<li class="has-separator">
				<router-link :to="{name: 'Home'}">Home</router-link>
			</li>
			<li class="is-marked">
				<a href="#"> {{ getBreadcrumb() }}</a>
			</li>
		</ul>
	</div>
</template>

<script>
	import {mapActions, mapGetters} from "vuex";
	export default {
		computed: {...mapGetters("cat", ["getCategories", "status"])},
		methods: {
			getBreadcrumb() {
				if (this.$route.name == "ProductsByType") {
					return this.$route.params.type;
				}
				return this.getCategories.find((cat) => cat.id == this.$route.params.id).name;
			},
		},
	};
</script>

<style></style>
